import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

export class Delay<V = any, E = any, C = any> extends Pass<V, E, C> {
    constructor(protected source?: AnySourceStream<V, E, C>, protected delayTimeout?: number) {
        super(source)
    }

    value(value: V) {
        setTimeout(() => {
            this._value(value)
        }, this.delayTimeout)
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        delay<T = DV>(delay: number): MirrorStream<DV, DE, DC>
    }
}

Stream.prototype.delay = function <V, E, C>(this: AnySourceStream<V, E, C>, delay: number) {
    return new Delay(this, delay) // tslint:disable-line:no-invalid-this
}
